import Typography from "@mui/material/Typography";

export default function SubHeader({ children, ...props }: React.ComponentProps<typeof Typography>) {
   const { sx, ...otherProps } = props

   return (
      <Typography {...otherProps} sx={{
         ...sx,
         fontSize: '14px',
         fontWeight: '700',
         lineHeight: '48px',
         letterSpacing: '0.10000000149011612px',
         textAlign: 'left',
         opacity: 0.6
      }}>
         {children}
      </Typography>
   )
}
